import './FacilityInfoTabs.less'
import { Descriptions, Spin } from 'antd'
import type { DescriptionsProps } from 'antd'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'

function FacilityInfoTabs(props: any) {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const { flrNo, hoCnt } = props
  const facilityStore = useStore('facilityStore')
  const [table1Items, setTable1Items] = useState<DescriptionsProps['items']>([])
  const [table2Items, setTable2Items] = useState<DescriptionsProps['items']>([])
  const [table3Items, setTable3Items] = useState<DescriptionsProps['items']>([])
  const [table4Items, setTable4Items] = useState<DescriptionsProps['items']>([])
  const [table5Items, setTable5Items] = useState<DescriptionsProps['items']>([])
  const [Loading, setLoading] = useState(false)
  const [resultShow, setResultShow] = useState(true)
  useEffect(() => {
    setLoading(true)
    const id = localStorage.getItem('JSESSIONID') || ''
    const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id
    facilityStore.queryBuildInfo(id2).then((res: any) => {
      if (res.code === 200) {
        const data = res.result
        setTable1Items([
          {
            key: '1',
            label: '건물명',
            children: data.brtitleinfo.bldgNm,
            span: 4,
          },
          {
            key: '2',
            label: '주용도',
            children: data.brtitleinfo.museCdNm,
            span: 4,
          },
          {
            key: '3',
            label: '구조물',
            children: data.brtitleinfo.strctCdNm,
            span: 4,
          },
          {
            key: '4',
            label: '준공일',
            children: data.brtitleinfo.useAprvYmd,
            span: 2,
          },
          {
            key: '5',
            label: '층/실',
            children: `${flrNo}층/${hoCnt}실`,
            span: 2,
          },
          {
            key: '6',
            label: '대지면적',
            children: `${data.brtitleinfo.siar}㎡`,
            span: 2,
          },
          {
            key: '7',
            label: '건축면적',
            children: `${data.brtitleinfo.bdar}㎡`,
            span: 2,
          },
          {
            key: '8',
            label: '지역(구)',
            children: data.brtitleinfo.areaGu,
            span: 4,
          },
          {
            key: '9',
            label: '소유권',
            children: data.brtitleinfo.ownrNm,
            span: 4,
          },
        ])
        if (data.exspInfo.length > 0) {
          const arr: DescriptionsProps['items'] = []
          // eslint-disable-next-line array-callback-return
          data.exspInfo.map((item: any, index: number) => {
            arr.push(
              {
                key: index * data.exspInfo.length,
                labelStyle: {
                  background: '#fafafa',
                },
                children: item.exspSeCdNm,
                contentStyle: {
                  background: '#fafafa',
                  paddingLeft: 90,
                },
                span: 4,
              },
              {
                key: index * data.exspInfo.length + 1,
                label: '시설명',
                children: item.fcltNm,
                span: 2,
              },
              {
                key: index * data.exspInfo.length + 2,
                label: '개수',
                children: item.qy,
                span: 2,
              },
            )
          })
          setTable2Items(arr)
        }
        if (data.mnncMngSttuList.length > 0) {
          const arr: DescriptionsProps['items'] = []
          // eslint-disable-next-line array-callback-return
          data.mnncMngSttuList.map((item: any, index: number) => {
            arr.push(
              {
                key: index * data.mnncMngSttuList.length,
                label: '건물명',
                children: data.brtitleinfo.bldgNm,
                span: 4,
              },
              {
                key: index * data.mnncMngSttuList.length + 1,
                label: '운영방식',
                children: item.operMthdCn,
                span: 4,
              },
              {
                key: index * data.mnncMngSttuList.length + 2,
                label: '운영관리자',
                children: item.mngrNm,
                span: 2,
              },
              {
                key: index * data.mnncMngSttuList.length + 3,
                label: '관리인력',
                children: item.mngrCnt,
                span: 2,
              },
              {
                key: index * data.mnncMngSttuList.length + 4,
                label: '운영비 마련',
                children: item.oexpMbyNm,
                span: 4,
              },
            )
          })
          setTable3Items(arr)
        }
        setTable4Items(
          [
            {
              key: '1',
              label: '1월',
              children: data.fctsOprtngInfo.janOprtngCnt,
            },
            {
              key: '2',
              label: '2월',
              children: data.fctsOprtngInfo.febOprtngCnt,
            },
            {
              key: '3',
              label: '3월',
              children: data.fctsOprtngInfo.marOprtngCnt,
            },
            {
              key: '4',
              label: '4월',
              children: data.fctsOprtngInfo.aprOprtngCnt,
            },
            {
              key: '5',
              label: '5월',
              children: data.fctsOprtngInfo.mayOprtngCnt,
            },
            {
              key: '6',
              label: '6월',
              children: data.fctsOprtngInfo.junOprtngCnt,
            },
            {
              key: '7',
              label: '7월',
              children: data.fctsOprtngInfo.julyOprtngCnt,
            },
            {
              key: '8',
              label: '8월',
              children: data.fctsOprtngInfo.augOprtngCnt,
            },
            {
              key: '9',
              label: '9월',
              children: data.fctsOprtngInfo.sepOprtngCnt,
            },
            {
              key: '10',
              label: '10월',
              children: data.fctsOprtngInfo.octOprtngCnt,
            },
            {
              key: '11',
              label: '11월',
              children: data.fctsOprtngInfo.novOprtngCnt,
            },
            {
              key: '12',
              label: '12월',
              children: data.fctsOprtngInfo.decOprtngCnt,
            },
          ],
        )

        if (data.mnncMngMndHstryList.length > 0) {
          const arr: DescriptionsProps['items'] = []
          // eslint-disable-next-line array-callback-return
          data.mnncMngMndHstryList.map((item: any, index: number) => {
            arr.push(
              {
                key: index,
                label: item.mnncMngMndHstrySeCdNm,
                children: (
                      <>
                        {item.cn}
                      </>
                ),
                span: 4,
              },
            )
          })
          setTable5Items(arr)
        }
        setLoading(false)
      }
      else {
        setLoading(false)
        setResultShow(false)
      }
    })
  }, [flrNo, hoCnt])

  return (
        <div className={'FacilityInfoTabs'}>
          {
            resultShow
              ? (
                    <Spin tip="검색..." size="large" spinning={Loading}>
                      <div className={'table1Part'}>
                        <Descriptions title="건축물 정보" size={'small'} bordered items={table1Items} />
                      </div>
                      <div className={'table2Part'}>
                        <Descriptions title="공간정보" size={'small'} bordered items={table2Items} />
                      </div>
                      <div className={'table3Part'}>
                        <Descriptions title="유지·관리현황" size={'small'} bordered items={table3Items} />
                      </div>
                      <div className={'table4Part'}>
                        <Descriptions title="시설물 가동현황" layout="vertical" size={'small'} bordered items={table4Items} />
                      </div>
                      <div className={'table5Part'}>
                        <Descriptions title="개보수·리모델링" size={'small'} bordered items={table5Items} />
                      </div>
                    </Spin>
                )
              : (
                    <div className={'not-info'}>
                      결과가 없습니다.
                    </div>
                )
          }
        </div>
  )
}

export default observer(FacilityInfoTabs)
